import * as yup from 'yup'
import * as Types from 'apps/fleet-planner/types'

const requiredMessage = 'This field is required.'

export interface INewTruck
  extends Pick<Types.ITruck, 'truckNumber' | 'motorCarrier' | 'motorCarrierId'> {}

/**
 * Creates a new truck
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Equipment/post_trucks
 */
export const TruckSchema = yup.object<INewTruck>({
  truckNumber: yup.string().required(requiredMessage),
  motorCarrierId: yup.number().required(requiredMessage),
  motorCarrier: yup.object({
    id: yup.number().required(requiredMessage),
    name: yup.string(),
  }),
})

export type TruckSchemaType = yup.InferType<typeof TruckSchema>
